import TempPage from './TempPage'

export default function ResourcesPage() {
  return <TempPage title="Coming Soon" error="Resources" subtitle="" />
}
